import { PlainButton, Menu } from "@jugl-web/ui-kit";
import { cx, useTranslations } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import { ReactComponent as BinIcon } from "./assets/bin.svg";
import { ReactComponent as MoreIcon } from "./assets/more.svg";
import { ReactComponent as UploadIcon } from "./assets/upload.svg";

interface EditableMediaContainerProps {
  children: ReactNode;
  className?: string;
  onSelectNew: () => void;
  onRemove: () => void;
}

export const EditableMediaContainer: FC<EditableMediaContainerProps> = ({
  children,
  className,
  onSelectNew,
  onRemove,
}) => {
  const { t } = useTranslations();

  return (
    <div className={cx("group relative", className)}>
      {children}
      <Menu
        placement="top"
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger
            ref={triggerRef}
            as={PlainButton}
            className={cx(
              "absolute -top-2.5 -right-2.5 flex h-8 w-8 items-center justify-center rounded-full border border-solid border-[#F2F2F2] bg-white transition-opacity group-hover:opacity-100 hover:opacity-100",
              isOpen ? "opacity-100" : "opacity-0"
            )}
          >
            <MoreIcon />
          </Trigger>
        )}
        autoClose
        sections={[
          [
            {
              id: "select",
              label: t({
                id: "cx-ai-agents-page.select-new-media",
                defaultMessage: "Select new",
              }),
              icon: <UploadIcon />,
              onSelect: onSelectNew,
            },
            {
              id: "remove",
              label: t({
                id: "cx-ai-agents-page.remove-media",
                defaultMessage: "Remove",
              }),
              icon: <BinIcon />,
              onSelect: onRemove,
            },
          ],
        ]}
      />
    </div>
  );
};
